module.exports = __webpack_public_path__ + "static/media/Политика за защита на личните данни.767f27d8.pdf";